<template>
  <div class="list-item-grid py-1">
    <div class="list-item-grid__icon-block">
      <slot name="icon" :user="user">
        <v-icon icon="$user" size="40" />
      </slot>
    </div>

    <div class="list-item-grid__details-block d-flex flex-column justify-center px-2">
      <div :data-testid="`users-table-name-row-${index}`" class="subtitle2">
        {{ user?.name }}
      </div>
      <div :data-testid="`users-table-email-row-${index}`" class="body2">
        {{ user?.email }}
        <template v-if="user?.aliases?.length"> +{{ user.aliases.length }} </template>
      </div>
      <slot v-if="hasDetailsExtraSlot" name="details-extra" :user="user" :index="index" />
    </div>

    <div class="list-item-grid__status-block">
      <slot name="status" :errors-list="errorsList" :index="index">
        <v-tooltip v-if="errorsList.length > 0" open-delay="300" location="top">
          <template #activator="{ props }">
            <div class="d-flex align-center text-no-wrap">
              <div class="caption text-red-dark">
                <template v-if="errorsList.length > 1">
                  <span class="mr-1">
                    {{ $t("mspUsersPage.statuses.nIssues", { n: errorsList.length }) }}
                  </span>
                  <v-icon
                    :data-testid="`users-table-icon-row-${index}`"
                    icon="$warning"
                    v-bind="props"
                  />
                </template>
                <template v-else>
                  <span class="mr-1">
                    {{ $t(`mspUsersPage.statuses.${errorsList[0]}`) }}
                  </span>
                  <v-icon :data-testid="`users-table-icon-row-${index}`" icon="$warning" />
                </template>
              </div>
            </div>
          </template>
          <div v-for="error in errorsList" :key="error">
            {{ $t(`mspUsersPage.statuses.${error}`) }}
          </div>
        </v-tooltip>
        <v-tooltip v-else open-delay="300" location="top">
          <template #activator="{ props }">
            <v-icon
              :data-testid="`users-table-icon-row-${index}`"
              v-bind="props"
              icon="$circleCheck"
            />
          </template>
          {{ $t("general.noTickets") }}
        </v-tooltip>
      </slot>
    </div>

    <div v-if="hasBottomContent" class="list-item-grid__bottom-block">
      <slot name="bottom" :user="user" :index="index" />
    </div>
  </div>
</template>

<script setup lang="ts" generic="T extends UserBaseListItem">
import { computed, useSlots } from "vue";
import type { UserBaseListItem } from "@/_store/users.module";

withDefaults(
  defineProps<{
    user: T;
    index: number;
    errorsList: string[];
  }>(),
  {
    errorsList: () => [],
  }
);

const slots = useSlots();

const hasDetailsExtraSlot = computed(() => Boolean(slots["details-extra"]));
const hasBottomContent = computed(() => Boolean(slots.bottom));
</script>
